import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useEffect, useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { isEmptyVal } from "../../../utils/helpers";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ContentRoutes } from "../../../navigation/NavConstant";

const CompanyProductBulkAction = ({
  checkedKeys,
  setCheckedKeys,
  onBulkDeleteProduct,
  permission,
  ...props
}: {
  checkedKeys: any;
  setCheckedKeys: Function;
  onBulkDeleteProduct: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const [loader, setLoading] = useState(true);
  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkDeleteModal(true);
    let msg = t("CONFIRM_ACTION", {
      action: t("DELETE").toLowerCase(),
      entity: t("PRODUCT").toLowerCase(),
    });
    setBulkActionMessage(msg);
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  return (
    <div className="product-action col-md-8 customer-action">
      <React.Fragment>
        {permission.back_to_list && (
          <Link to={ContentRoutes.COMPANIES}>
            <Button appearance="primary" color="blue" type="button">
              {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
              {t("LIST").toLocaleLowerCase()}
            </Button>
          </Link>
        )}
        {permission.delete && (
          <Button onClick={() => bulkDelete()} color="red" type="button">
            {t("DELETE")}
          </Button>
        )}
      </React.Fragment>

      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
      <AlertModal
        open={openBulkDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkDeleteProduct();
            setOpenBulkDeleteModal(false);
          } else {
            setOpenBulkDeleteModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
    </div>
  );
};

export default CompanyProductBulkAction;
